export default __webpack_public_path__ + "static/media/goldenbeerooftop2021.3a1539bf.mp4";